import Section from "components/layout/Section";
import { typeOfPoint, useSelectPoint, useSelectedRobots } from "./FleetPage";
import { Fleet } from "types/fleet";
import MapView, { MapViewProps } from "components/navigation/map/MapView/MapView";
import { useMultiARCs } from "providers/MultiARCsControlProvider";
import { useMemo } from "react";
import { MapMetadata } from "arcjs/common/navigation";
import { Landmark, Robot } from "arcjs/common/arc_devices";
import { DUMMY_MAP_INFO } from "lib/consts/testing";
import { Point2D } from "arcjs/common/geometry";

const MapViewWithDummyData = (props: MapViewProps & { fleet: Fleet }) => {
    const { fleet } = props;
    const { arcs: allArcs } = useMultiARCs();
    const arcs = useMemo(() => {
        const matched: (typeof allArcs)[keyof typeof allArcs][] = [];
        for (const serialNumber in allArcs) {
            if (fleet.arcs.find((a) => a.serialNumber === serialNumber))
                matched.push(allArcs[serialNumber]);
        }
        return matched;
    }, [fleet, allArcs]);
    const mapMetadata: MapMetadata = useMemo(() => {
        return {
            id: "test",
            name: "test",
            created_time: 0,
            desc: "", // normally empty
            width: 1290,
            height: 852,
            resolution: 1,
            origin: { x: 1290 / 2, y: 852 / 2 },
        };
    }, []);
    const robots: Robot[] = useMemo(
        () => arcs.filter((a) => a.state.robotPose).map((a) => ({ serialNumber: a.serialNumber, name: a.info.name, pose: a.state.robotPose! })),
        [arcs]
    );
    const landmarks: Landmark[] = useMemo(() => DUMMY_MAP_INFO[0].landmarks.normalPoints, []);
    return (
        <MapView
            {...props}
            stcmListBaseUrl={null}
            robots={robots}
            landmarks={landmarks}
            mapId="test"
            mapMetadata={mapMetadata}
            mapViewData={require(`assets/imgs/testings/Map.png`)}
        />
    );
};

const MapSection = ({
    className = "",
    fleet,
}: React.HTMLProps<HTMLDivElement> & { fleet: Fleet }) => {
    const { robotSelection } = useSelectedRobots();

    const { selectPoint, selectedPoint, pendingSelectPoint } = useSelectPoint();

    const selectedPoint2D =
        pendingSelectPoint && selectedPoint
        ? (typeOfPoint(selectedPoint) === "Landmark"
            ? (selectedPoint as Landmark).pose.position
            : (selectedPoint as Point2D))
        : undefined;

    const mapOnClick = (point: Point2D) => selectPoint(point);
    const landmarkOnClick = (landmark: Landmark) => selectPoint(landmark);
    const robotOnClick = pendingSelectPoint
        ? undefined
        : ({ serialNumber }, { multiSelect }) => {
              multiSelect
                  ? robotSelection.toggle(serialNumber)
                  : robotSelection.replaceWithOne(serialNumber);
          };

    return (
        <Section className={className}>
            <Section.Header more={{ link: `/map/edit`, text: "Edit" }}>Map</Section.Header>
            <Section.Content>
                <MapViewWithDummyData
                    fleet={fleet}
                    onClick={mapOnClick}
                    landmarkOnClick={landmarkOnClick}
                    robotOnClick={robotOnClick}
                    selectedPoint={selectedPoint2D}
                />
            </Section.Content>
        </Section>
    );
};
export default MapSection;
